import { useTheme } from '@mui/material';
import {
  ActiveStatus,
  activeStatusByValue,
  JobStatusByNumber,
  roleStatusByValue,
} from './typedEnums';

export const useJobStatusColor = (activeStatus: ActiveStatus, status: JobStatusByNumber) => {
  const theme = useTheme();

  switch (status) {
    case roleStatusByValue.archived:
      return {
        textColor: theme.palette.warning.main,
      };
    case roleStatusByValue.active:
      return activeStatus === activeStatusByValue.activeOpen
        ? {
            textColor: theme.palette.primary.main,
          }
        : {
            textColor: theme.palette.error.main,
          };
    default:
      return {
        textColor: theme.palette.text.tertiary,
      };
  }
};
